import { Layout } from '@/components/Layout/Layout';
import type { ISearchOverlay } from 'components/HeaderNavigation/components/MobileNavigation';
import ClientPromotionsPage from 'components/PageLevelComponents/ClientPromotionsPage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { PromotionsPageController } from 'server/controller/page/products/promotionsPageController';
import type { IProductsPromotionsPageResource } from 'server/resource/page/productsPromotionsPageResource';
import type { IGlobalMetaData } from 'types/GlobalMetadata';

const RootPage = (props: IProductsPromotionsPageResource) => {
  const {
    metaData,
    searchItemLabels,
    recipeCopy,
    data,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    promotionsDictionary,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientPromotionsPage
        globalMetadata={metaData as IGlobalMetaData}
        data={data}
        difficultyCopy={difficultyCopy as Record<string, string>}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData as ISearchOverlay}
        recipeCopy={recipeCopy}
        promotionsLabels={promotionsDictionary as unknown as Record<string, string>}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return PromotionsPageController.getCachedPromotionsPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug : [],
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
